import axios from 'axios';
import store from '../redux/store/store';
const API_AUTH_URL = import.meta.env.VITE_API_URL;

const invoiceService = {

  fetchInvoices: async (userId, page = 1, pageSize = 10, filters) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`${API_AUTH_URL}/Invoice`, {
        params: {
          UserId: userId,
          page, pageSize,
          WithOrder: true,
          WithUser: true,
          WitAddress: true,
          ...filters
        },
        headers: { Authorization: `Bearer ${userToken}` }
      });

      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
      throw error;
    }

  },


  addInvoicesApi: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      data.recordType = parseInt(data.recordType, 10);
      data.status = parseInt(data.status, 10);
      data.type = parseInt(data.type, 10);
      data.profileType = parseInt(data.profileType, 10);
      data.paymentMeansCode = parseInt(data.paymentMeansCode, 10);
      data.invoiceRecordType = parseInt(data.invoiceRecordType, 10);


      const response = await axios.post(`/Invoice`, data, { headers: { Authorization: `Bearer ${userToken}` } });
      return response.data;
    } catch (error) {
      console.error('Error add invoices:', error);
      throw error;
    }
  },


  updateInvoicess: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      data.recordType = parseInt(data.recordType, 10);
      data.status = parseInt(data.status, 10);
      data.type = parseInt(data.type, 10);
      data.profileType = parseInt(data.profileType, 10);
      data.paymentMeansCode = parseInt(data.paymentMeansCode, 10);
      data.invoiceRecordType = parseInt(data.invoiceRecordType, 10);
      const response = await axios.put(`/Invoice`, data, { headers: { Authorization: `Bearer ${userToken}` } });
      return response.data;
    } catch (error) {
      console.error('Error update invoices:', error);
      throw error;
    }
  },
  addCustomerInvoicess: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(`/InvoiceCustomer`, data, { headers: { Authorization: `Bearer ${userToken}` } });
      return response.data;
    } catch (error) {
      console.error('Error add customer:', error);
      throw error;
    }
  },



  fetchInvoicesCustomer: async (userId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`/InvoiceCustomer?UserId=${userId}`, { headers: { Authorization: `Bearer ${userToken}` } });
      if (response && response.data) {

        return response.data;
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },


  createInvoice: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;

      const response = await axios.post(`${API_AUTH_URL}/Invoice`, data, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json'
        }
      });

      return response.data;
    } catch (error) {
      console.error('Invoice API Error:', {
        message: error.message,
        response: error.response?.data,
        data: error.response?.data?.data
      });
      throw error;
    }
  },



  createRangeInvoice: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;

      const response = await axios.post(`${API_AUTH_URL}/Invoice/CreateRange`, data, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json'
        }
      });

      return response.data;
    } catch (error) {
      console.error('Invoice API Error:', {
        message: error.message,
        response: error.response?.data,
        data: error.response?.data?.data
      });
      throw error;
    }
  },


  fetchInvoicesStatus: async (invoiceId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`/InvoiceTransfer?InvoiceId=${invoiceId}&PageNumber=1&PageSize=20`, { headers: { Authorization: `Bearer ${userToken}` } });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },

  // Fatura silme fonksiyonu
  deleteInvoice: async (invoiceId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.delete(`/Invoice?id=${invoiceId}`, {
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      });
       return response.data;
    } catch (error) {
       return {
        success: false,
        message: 'Fatura silme sırasında bir hata oluştu',
        data : false
      };
    }
  },
  
  fetchAllInvoicesCustomer: async (query) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`/InvoiceCustomer?UserId=${query.userId}&Page=${query.pageNumber}&WithPagination=true&search=${query.search}`, { headers: { Authorization: `Bearer ${userToken}` } });
      if (response && response.data) {

        return response.data;
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },
 updateInvoicesCustomer: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.put(`/InvoiceCustomer`, data, { headers: { Authorization: `Bearer ${userToken}` } });
      return response.data;
    } catch (error) {
      console.error('Error update invoices:', error);
      throw error;
    }
  },


};


export default invoiceService;
